<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YufTdR/images/cover.jpg?1684515194395" alt="This image is the cover for the book The Peril and Promise of Christian Liberty, Emory University Studies in Law and Religion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Peril and Promise of Christian Liberty, Emory University Studies in Law and Religion
      </h1>
      <p class="bookDescription body article font2">
        <p>How do Christians determine when to obey God even if that means disobeying other people? In this book W. Bradford Littlejohn addresses that question as he unpacks the magisterial political-theological work of Richard Hooker, a leading figure in the sixteenth-century English Reformation.<br/><br/> Littlejohn shows how Martin Luther and other Reformers considered Christian liberty to be compatible with considerable civil authority over the church, but he also analyzes the ambiguities and tensions of that relationship and how it helped provoke the Puritan movement. The heart of the book examines how, according to Richard Hooker, certain forms of Puritan legalism posed a much greater threat to Christian liberty than did meddling monarchs. In expounding Hooker's remarkable attempt to offer a balanced synthesis of liberty and authority in church, state, and conscience, Littlejohn draws out pertinent implications for Christian liberty and politics today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        W. Bradford Littlejohn
      </h2>
      
      <p class="authorDescription body article"><B>W. Bradford Littlejohn</B>&#160;serves as director of the Davenant Trust, a nonprofit organization dedicated to the renewal of Christian wisdom for the contemporary church. He is also the author of&#160;<I>Richard Hooker: A Companion to His Life and Work</I>&#160;and numerous articles and book chapters in Reformation studies and Christian ethics.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2636df30